import { Provider } from 'mobx-react';
import * as React from 'react';
import { Router } from 'react-router';

import stores, { history } from '../stores';

import Layout from './layout/Layout';
import 'bootstrap/dist/css/bootstrap.min.css';

class App extends React.Component {
  render() {
    return (
      <Provider {...stores}>
        <Router history={history}>
          <Layout />
        </Router>
      </Provider>
    );
  }
}

export default App;
